import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { map, Observable, startWith } from 'rxjs';
import { LoginService } from '../../../app/service/login/login.service';

@Component({
  selector: 'app-cambiar-perfil-dialog',
  //standalone: true,
  //imports: [],
  templateUrl: './cambiar-perfil-dialog.component.html',
  styleUrl: './cambiar-perfil-dialog.component.scss'
})
export class CambiarPerfilDialogComponent  {

  controlSucursal = new FormControl(localStorage.getItem('profile'));
  sucursales = [];
  filteredSucursales: Observable<any>;
  
  constructor( 
      @Inject(MAT_DIALOG_DATA) 
      public data: {}, 
      private loginService: LoginService,
      public dialogRef: MatDialogRef<CambiarPerfilDialogComponent>) {
        const storedProfiles = localStorage.getItem('userProfiles');

        if (storedProfiles) {
            // Se convierte el string de vuelta a un arreglo de objetos
            const parsedProfiles = JSON.parse(storedProfiles);
            parsedProfiles.forEach(element => {
              this.sucursales.push(element.name)
            });
            console.log(this.sucursales)
        }
        
  }

  closeDialog(){
    this.dialogRef.close()
  }

  ngOnInit() {
    this.filteredSucursales = this.controlSucursal.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSucursales(value || '')),
    );
  }

      
  private _filterSucursales(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.sucursales.filter(street => this._normalizeValue(street).includes(filterValue));
  }
     
  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  aceptarCambio(){
    this.loginService.setVariableSession('profile', this.controlSucursal.value)
    window.location.reload()
  }
}